export const PERIOD = {
	MATCH: 0,
	FIRSTHALF: 1,
	SECONDHALF: 2,
	NONE: 3,
	OVERTIME: 4,
	PENALTY_SHOOTOUT: 5
};
